import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

/**
 * Remove stale service workers that cache the app shell (an old Angular ngsw or a
 * prior SW iteration). Such workers keep serving an outdated index.html + chunk
 * manifest, so users get stuck on an old build even after a deploy — the recurring
 * "I don't see the new UI" symptom. We keep ONLY our push-only worker (push-sw.js,
 * which caches nothing). If a stale *caching* worker was controlling the page, we
 * clear its Cache Storage and reload once so the fresh network build takes over.
 */
async function cleanupStaleServiceWorkers(): Promise<void> {
	if (!('serviceWorker' in navigator)) {
		return;
	}
	try {
		const controller = navigator.serviceWorker.controller;
		const controllerIsStale = !!controller && !controller.scriptURL.includes('push-sw.js');

		const regs = await navigator.serviceWorker.getRegistrations();
		for (const reg of regs) {
			const url =
				reg.active?.scriptURL || reg.waiting?.scriptURL || reg.installing?.scriptURL || '';
			// Preserve our push-only worker; unregister every app-shell cacher.
			if (!url.includes('push-sw.js')) {
				await reg.unregister();
			}
		}

		if (controllerIsStale) {
			// Old ngsw stored stale app-shell assets in Cache Storage — wipe them.
			if ('caches' in window) {
				const keys = await caches.keys();
				await Promise.all(keys.map((k) => caches.delete(k)));
			}
			// One-time reload (guarded) so the page detaches from the dead SW.
			if (!sessionStorage.getItem('sw-cleanup-reloaded')) {
				sessionStorage.setItem('sw-cleanup-reloaded', '1');
				location.reload();
			}
		}
	} catch {
		/* best-effort — never block boot on SW cleanup */
	}
}

cleanupStaleServiceWorkers().finally(() => {
	bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
